import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css']
})
export class PaginationComponent {
  @Input() totalCount: number = 0;  // Total number of items
  @Input() pageSize: number = 50;   // Number of items per page
  @Input() currentPage: number = 1; // Current page

  @Output() pageChange: EventEmitter<any> = new EventEmitter(); // Emit when page changes
  @Output() refresh: EventEmitter<void> = new EventEmitter();  // Emit when refresh is clicked

  // When the page changes (pagination)
  onPageChange(event: any) {
    this.pageChange.emit(event);
  }
  // When refresh button is clicked
  onRefresh() {
    this.pageChange.emit(event);

  }
}
